import TransportMode from '@/pure/TransportMode';

function checkNullable(item) {
  return item || 'Non renseigné';
}

function matchTransportType(item) {
  const mode = TransportMode.find(type => item === type.transportType);
  return mode ? mode.key : 'none';
}

export function reduceStudy(data) {
  const actualSites = data.sites.filter(item => item.type === 'Actual');

  data.withWalkingTimes = data.collaborators
    .flatMap(collaborator => collaborator.sites)
    .flatMap(site => site.times)
    .some(time => 'walking' in time && time.walking != null);

  const optimizedMaterials = TransportMode.filter(item => item.optimizedMaterial)
    .map(item => item.key)
    .filter(item => (data.withWalkingTimes ? true : !['bicycle', 'walking'].includes(item)));

  data.collaborators = data.collaborators.map(item => {
    const { address, details, id, serial, sites, non_observable } = item;
    const reducedDetails = details
      ? {
          actualTime: details.actual_time,
          actualSite: actualSites.find(site => site.id.toString() === details.actual_site.toString()).name,
          actualSiteID: details.actual_site.toString(),
          age: details.age,
          contractType: details.contract_type,
          days: details.days,
          filter1: checkNullable(details.filter1),
          filter2: checkNullable(details.filter2),
          offLimit: details.off_limit,
          jllId: details.jll_id,
          country: checkNullable(details.country),
          region: checkNullable(details.locality),
          seniority: checkNullable(details.seniority),
          service: checkNullable(details.service),
          unrecognized: details.unrecognized,
          transportType: matchTransportType(details.transport_type),
        }
      : {};

    const reducedSites = sites.map(site => {
      const times = site.times[0];
      const materials = [];
      for (const key in times) {
        if (optimizedMaterials.find(item => item === key)) {
          materials.push({
            key,
            value: times[key] || -1,
          });
        }
      }

      // sort materials by this order of priority for when two optimized mode results are tied
      const orderOfPriority = ['public', 'public2025', 'public2030', 'public2027', 'public2031', 'private', 'bicycle', 'walking'];
      materials.sort((a, b) => orderOfPriority.indexOf(a.key) - orderOfPriority.indexOf(b.key));

      let optimized = materials.reduce((acc, mode) => (mode.value > 0 && mode.value < acc.value ? mode : acc), {
        key: 'none',
        value: Number.MAX_SAFE_INTEGER,
      });

      const walkingMaterial = materials.find(item => item.key === 'walking');
      if (
        optimized.key === 'bicycle' &&
        walkingMaterial &&
        walkingMaterial.value && // needed for older studies without walking values
        walkingMaterial.value <= 15
      ) {
        optimized = walkingMaterial;
      }

      const reducedSite = {
        ...site,
        optimizedSite: optimized.key,
      };
      reducedSite.times[0].optimized = optimized.value;

      return reducedSite;
    });

    const newCollaborator = {
      address,
      details: reducedDetails,
      id,
      latLng: item.lat_lng,
      serial,
      non_observable,
      sites: reducedSites,
    };

    return non_observable ? Object.freeze(newCollaborator) : newCollaborator;
  });

  data.customTransport =
    data.collaborators.filter(c => {
      return c.details.transportType !== 'none' && !c.details.offLimit && !c.details.unrecognized;
    }).length > 0;

  data.public_maximum_travel_time = data.public_maximum_travel_time && data.public_maximum_travel_time !== 0 ? data.public_maximum_travel_time : 90;
  data.private_maximum_travel_time = data.private_maximum_travel_time && data.private_maximum_travel_time !== 0 ? data.private_maximum_travel_time : 90;
  data.bicycle_maximum_travel_time = data.bicycle_maximum_travel_time && data.bicycle_maximum_travel_time !== 0 ? data.bicycle_maximum_travel_time : 60;
  data.walking_maximum_travel_time = data.walking_maximum_travel_time && data.walking_maximum_travel_time !== 0 ? data.walking_maximum_travel_time : 60;

  return {
    study: data,
  };
}
